module.exports = __webpack_public_path__ + "static/c9d96afbf61594e37d83369f064ab085c75ffed8842893a19fd7668e039cf323-b3acb52a9421c6e992a8149d3983aca3.jpeg";